import React, { useState, useContext, useEffect, useRef } from "react";
import "../../css/dashboard.scss";
import Leftbar from "../dashboard.leftbar.component/dashboard.leftbar.component";
import RightArea from "../dashboard.rightarea.component/dashboard.rightarea.component";
import AuthContext from "../../context/userAuth.context";
import CharacterContext from "../../context/CharacterContext";
import Timer from "../../Utils/Timer";
import axios from "axios";
import AccountSetting from "../dashboard.rightarea.component/AccountSetting";
import DLoader from "../../assets/Loader/mainLoader.json";
import Lottie from "lottie-web";

export const Dashboard = ({ data }) => {
  const {
    Tip,
    authenticationData,
    setAuthenticationData,
    apiBaseurl,
    ExpiryCountdown,
    setExpiryCountdown,
    setDivName,
    DivName,
    setUserData,
    UserData,
  } = useContext(AuthContext);

  const [CharacterAssets, setCharacterAssets] = useState({
    Male: {
      head: [],
      hair: [],
      Mouth: [],
      Nose: [],
      Eyes: {
        eye: [],
        EyeBrows: [],
      },
      Shirts: {
        Shirt: [],
        Sweaters: [],
        Jackets: [],
      },
      Bottoms: [],
      Shoes: [],
      Cap: [],
      Glasses: [],
      Mask: [],
      EarWear: [],
    },
    Female: {
      head: [],
      hair: [],
      Mouth: [],
      Nose: [],
      Eyes: {
        eye: [],
        EyeBrows: [],
      },
      Shirts: {
        Shirt: [],
        Sweaters: [],
        Jackets: [],
      },
      Bottoms: [],
      Shoes: [],
      Cap: [],
      Glasses: [],
      Mask: [],
      EarWear: [],
    },
  });

  const [DefaultCharacter, setDefaultCharacter] = useState({
    Male: [],
    Female: [],
  });

  useEffect(() => {
    sessionStorage.removeItem("createNewProject");
    sessionStorage.removeItem("myProjectData");
    sessionStorage.removeItem("CurrentChooseProjectId");
    let Name = JSON.parse(localStorage.getItem("DivName"));
    if (Name != "null" && Name != null) {
      setDivName(Name);
      localStorage.removeItem("DivName");
    }
    let charPop = localStorage.getItem("CharPopup");
    if(charPop && charPop != null){
      setCharPopup(charPop)
      localStorage.removeItem("CharPopup");
    }
    if (Categories.length == 0) {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL + "/api/Category/GetCategoriesList",
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            setCategories(response.data.result);
          }
        })
        .catch((error) => {});
    }
  }, []);

  const ShowPop = (params) => {
    setExpiryCountdown(false);
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    axios
      .get(authenticationData.ApiBaseURL + "/api/Account/RefreshToken", {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((response) => {
        setAuthenticationData({
          authenticationData: response.data,
          ApiBaseURL: apiBaseurl,
          isAuthenticated: true,
        });
        localStorage.setItem(
          "animation_studio_2.0_access_token",
          JSON.stringify(response.data)
        );
        let expireIn_ms = parseInt(response.data.expires_in);
        setTimeout(() => {
          setExpiryCountdown(true);
        }, expireIn_ms - 20000);
      })
      .catch((error) => {
        setAuthenticationData({
          authenticateData: authData,
          ApiBaseURL: apiBaseurl,
          isAuthenticated: false,
        });
      });
  };

  const [Categories, setCategories] = useState([]);

  const [CharPopup, setCharPopup] = useState(false);

  const [TempData, setTempData] = useState({
    popularTemplates: [],
    recentUsedTemplates: [],
  });

  const [redirect, setredirect] = useState({ path: null, status: false });

  const [Show, setShow] = useState(false);

  const [PopStyle, setPopStyle] = useState("");
  const [DeafultLoader, setDeafultLoader] = useState({
    played: false,
    stat: false,
    Message:""
  });
  const AnimationRef = useRef(null);
  useEffect(() => {
    if (DeafultLoader.stat) {
      Lottie.loadAnimation({
        container: AnimationRef.current,
        name: "DefaultLoader",
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: DLoader,
      });
    } else {
      if (DeafultLoader.played) {
        Lottie.destroy("DefaultLoader");
      }
    }
  }, [DeafultLoader]);
  return (
    <div className="dashboardBody">
      {DeafultLoader.stat && (
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "rgb(255 255 255 / 100%)",
            zIndex: "9999999",
            inset: "0px",
            position: "fixed",
          }}
        >
          <div
            ref={AnimationRef}
            style={{
              width: "300px",
              height: "300px",
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
          <div
            style={{
              position: "relative",
              left: "51%",
              top: "65%",
              transform: "translate(-50%, -50%)",
              display: "inline-block",
            }}
          >
            {DeafultLoader.Message?DeafultLoader.Message:"Loading... Please Wait."}
          </div>
        </div>
      )}
      <div className="bodyWrapper">
        <div className="bodyflex">
          <div className="workArea">
            {Tip.show === true && (
              <div
                className="InfoTippy"
                style={{ top: Tip.top + "px", left: Tip.left + "px" }}
              >
                <div className="poparrow"></div>
                <div dangerouslySetInnerHTML={{ __html: Tip.Data }}></div>
              </div>
            )}

            <CharacterContext.Provider
              value={{
                CharacterAssets,
                setCharacterAssets,
                DefaultCharacter,
                setDefaultCharacter,
                Categories,
                CharPopup,
                setCharPopup,
                redirect,
                setredirect,
                TempData,
                setTempData,
              }}
            >
              <div className="regularLayout">
                {Show && (
                  <AccountSetting PopStyle={PopStyle} UserData={UserData} />
                )}
                <Leftbar
                  setShow={setShow}
                  Show={Show}
                  setPopStyle={setPopStyle}
                  Editor={false}
                />
                <RightArea setDeafultLoader={setDeafultLoader} />
              </div>
            </CharacterContext.Provider>
          </div>
        </div>
      </div>

      {ExpiryCountdown && (
        <div
          className="nofifier-bg"
          onMouseMove={(event) => {
            setExpiryCountdown(false);
            let authData = JSON.parse(
              localStorage.getItem("animation_studio_2.0_access_token")
            );
            axios
              .get(
                authenticationData.ApiBaseURL + "/api/Account/RefreshToken",
                {
                  headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: "Bearer " + authData.access_token,
                  },
                }
              )
              .then((response) => {
                let userObj = {
                  email: response.data.email,
                  userName: response.data.userName,
                  id: response.data.User_Id,
                };
                setUserData(userObj);
                setAuthenticationData({
                  authenticationData: response.data,
                  ApiBaseURL: apiBaseurl,
                  isAuthenticated: true,
                });
                localStorage.setItem(
                  "animation_studio_2.0_access_token",
                  JSON.stringify(response.data)
                );
                let expireIn_ms = parseInt(response.data.expires_in);
                setTimeout(() => {
                  setExpiryCountdown(true);
                }, expireIn_ms - 20000);
              })
              .catch((error) => {
                setAuthenticationData({
                  authenticateData: authData,
                  ApiBaseURL: apiBaseurl,
                  isAuthenticated: false,
                });
              });
          }}
        >
          <div className="logOutCountDowntimerWrapper">
            <span class="material-icons-outlined session-expiry-warning-icon">
              warning
            </span>
            <label htmlFor="">
              Your session is going to expire in{" "}
              <Timer initialMinute={0} initialSeconds={15}></Timer> seconds and
              you will be redirected to login.
              <span className="TimerText">
                <br /> Please move your mouse to refresh you session.
              </span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
